import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { HhsgSharedHeaderComponent } from "./header.component";

import { HhsgSharedHeaderMenuComponent } from "./menu/header-menu.component";
import { HhsgSharedNavHeaderComponent } from "./nav-header/nav-header.component";
import { HhsgSharedNavMenuComponent } from "./nav-header/nav-menu/nav-menu.component";

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [
    HhsgSharedHeaderComponent,
    HhsgSharedHeaderMenuComponent,
    HhsgSharedNavHeaderComponent,
    HhsgSharedNavMenuComponent
  ],
  exports: [
    HhsgSharedHeaderComponent,
    HhsgSharedNavHeaderComponent
  ]
})
export class HhsgSharedHeaderModule {}